
import { useAuth } from '../../AuthContext';
import { Outlet, useNavigate } from 'react-router-dom';

import './UserDashboard.css';

const UserDashboard = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

 
       
    
  

  return (
    <div className="user-dashboard">
      <h2>Welcome to Your User Dashboard, {currentUser?.email}</h2>

      

      <div className="actions">
        <button onClick={() => navigate('/user-dashboard/user-profile')}>View Profile</button>
       
        <button onClick={() => navigate('/user-dashboard/user-chat')}>Chat with Admin</button>
      </div>
      
      <Outlet />
      
    </div>
  );
};

export default UserDashboard;
